import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Back from "../../../common/assets/images/Back.svg";
import Close from "../../../common/assets/images/Close.svg";
import moment from "moment";
import {
  Grid,
  Card,
  CardContent,
  Button,
  DialogTitle,
  Alert,
  AlertTitle,
  Dialog,
  DialogContent,
  Snackbar,
  useMediaQuery,
} from "@mui/material";
import { getAdminDetail } from "../../reducers/adminThunk";
import "../../../dataEntry/styles/DataEntry.scss";
import { Box } from "@mui/system";
import { deleteAdmin } from "../../reducers/wardThunk";
import {
  setErrorMessage,
  setsuccessMessage,
} from "../../../dataEntry/reducers/patientDataThunk";
import { ToastContainer, toast } from "react-toastify";

const DeleteAdmin = (props) => {
  const patient = useSelector((state) => state.patient);
  const user = useSelector((state) => state.user);
  const dbbranchdata = useSelector((state) => state.dashboard);
  const hospital_id = user.userProfile.hospital_id;
  const hospitalBranchId = user.branchdata.branch_id;
  const referralDrId =
    props && props.SelectedAdmin
      ? props.SelectedAdmin.id
      : props.SelectedAdmin.id;
      const selectedRole =
    props && props.selectedRole;
    const isMobile = useMediaQuery('(max-width:768px)');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const closeDialog = (e) => {
    e.preventDefault();
    props.onClose();
  };
  useEffect(() => {
    if (patient.errorMessage) {
      setTimeout(() => {
        dispatch(setErrorMessage(""));
      }, 10000);
    }
  }, [patient.errorMessage]);

  useEffect(() => {
    if (patient.successMessage) {
      setTimeout(() => {
        dispatch(setsuccessMessage(""));
      }, 10000);
    }
  }, [patient.successMessage]);

  const deleteselrecord = (e) => {
    e.preventDefault();
    dispatch(deleteAdmin(referralDrId))
      .unwrap()
      .then((resdata) => {
        //navigate("/AdminListing");

        toast.success("User Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        
      if (hospital_id) {
        const req = {
          hospital_id: hospital_id,
        };
      selectedRole != -1 ? (req.role_id = selectedRole) : null;
       dispatch(getAdminDetail(req));
      }
      });
      //dispatch(getAdminDetail({ hospital_id }));
    props.onClose();
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Dialog
        fullWidth="70%"
        maxWidth={props.maxWidth}
        open={props.open}
        onClose={props.onClose}
        className={isMobile ? 'report-dialogMobile' : 'report-dialog'}
      >
        <DialogTitle
          style={{
            borderBottom: "0.8px solid #f0f1fc",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Link
              to="/"
              className="FIle-left"
              onClick={closeDialog}
              style={{ marginRight: "20px" }}
            >
              <img
                src={Back}
                className="file-img-left"
                alt=""
                style={{ width: "12px" }}
              />
            </Link>
            <span>Delete Conformation</span>
          </div>
          <div>
            <Link to="/" className="FIle-right-extreme" onClick={closeDialog}>
              <img src={Close} alt="" />
            </Link>
          </div>
        </DialogTitle>
        <DialogContent>
          <Box>
            <form id="bmrn-form">
              <Card style={{ marginTop: 10 }} variant="none">
                <CardContent>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      <Alert severity="error">
                        <AlertTitle>
                          Are you sure you want to delete selected user
                          <br />
                          If yes please Re-Map the reportees manually if
                          applicable.
                        </AlertTitle>
                      </Alert>
                    </Grid>
                    <div className="formSection" 
                    style={{ display: "contents"}}>
                      <Grid container>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className="back"
                            onClick={closeDialog}
                          >
                            Back
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className={isMobile ? 'mobilePurple' : 'purple-add'}
                            type="submit"
                            onClick={(e) => deleteselrecord(e, referralDrId)}
                          >
                            <span>Delete</span>
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          </Box>
        </DialogContent>
      </Dialog>

      {patient.errorMessage && (
        <Snackbar
          open={patient.errorMessage}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="error" variant="filled">
            {patient.errorMessage}
          </Alert>
        </Snackbar>
      )}
      {patient.successMessage && (
        <Snackbar
          open={patient.successMessage}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="success" variant="filled">
            {patient.successMessage}
          </Alert>
        </Snackbar>
      )}
    </React.Fragment>
  );
};
export default DeleteAdmin;
